import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { EmptyState, Table } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { usePaginatedQuery } from "@/hooks/api/use-paginated-query";
import { PAGE_SIZE } from "./constants";
import { ItemOwnersTableFragment } from "./ItemOwnersTable.fragment";
import { ItemOwnersTableRow } from "./ItemOwnersTableRow";
import { ItemOwnersTableRowFragment } from "./ItemOwnersTableRow.fragment";
const query = graphql(`
    query ItemOwnersTableQuery(
      $item: ItemIdentifierInput!
      $limit: Int!
      $cursor: String
    ) {
      itemOwners(identifier: $item, limit: $limit, cursor: $cursor) {
        items {
          ...ItemOwnersTableRow
        }
        nextPageCursor
      }
    }
  `, [ItemOwnersTableRowFragment]);
export const ItemOwnersTable = withSuspense(({
  item: itemKey
}) => {
  const item = readFragment(ItemOwnersTableFragment, itemKey);
  const {
    items,
    pagination
  } = usePaginatedQuery({
    query,
    variables: {
      item: {
        tokenId: item.tokenId,
        contractAddress: item.contractAddress,
        chain: item.chain.identifier
      },
      limit: PAGE_SIZE
    }
  }, v => v?.itemOwners, {
    pageSize: PAGE_SIZE
  });
  return <Table itemKey={(_, index) => index} items={items} renderRow={ItemOwnersTableRow} {...pagination} />;
}, {
  fallback: ItemOwnersTableSkeleton,
  errorFallback: <EmptyState variant="no-data" />
});
function ItemOwnersTableSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Table className="max-h-[600px]" itemKey={_temp} items={range(PAGE_SIZE).map(_temp2)} renderRow={ItemOwnersTableRow} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2() {}
function _temp(_, index) {
  return index;
}